import { modals } from "@mantine/modals";
import DataTable from "../../components/common/DataTable";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Image, Modal } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React from "react";
import { Link } from "react-router-dom";
import ViewModal from "../../banners/ViewModal";
import Head from "../../components/common/Head";
import useValidate from "../../hooks/useValidate";
import { deleteBanner, getBanners } from "../../utils/api";
import useStore from "../../utils/store";

const Banners = () => {
  const user = useStore((state) => state.user);

  
  const [modal2, setModal2] = React.useState(false);
  const [active, setActive] = React.useState({});
  const queryClient = useQueryClient();

  const { data = [], isLoading } = useQuery({
    queryKey: ["banners"],
    queryFn: async () => {
      const [success, response] = await getBanners();
      if (success) return response;
      return response;
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (id) => deleteBanner(id),
    onSuccess: (_, id) => {
      notifications.show({ message: "Banner deleted successfully", color: "green" });
      queryClient.invalidateQueries(["banners"]);
    },
    onError: (error) => {
      notifications.show({ message: error.message, color: "red" });
    },
  });

  useValidate();

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (text, record) => (
        <Image
          src={record.image}
          alt={record.image}
          w={80}
          h={80}
          fit="cover"
          radius="md"
          fallbackSrc="https://placehold.co/80x80?text=No+Image"
        />
      ),
    },
    {
      title: "Horizontal Banner",
      dataIndex: "horizontalBanner",
      key: "horizontalBanner",
      render: (text) => (
        <Image
          src={text}
          alt="Banner"
          w={120}
          h={68}
          fit="cover"
          radius="md"
          fallbackSrc="https://placehold.co/120x68?text=No+Image"
        />
      ),
    },
    {
      title: "Banner",
      dataIndex: "bannerType",
    },
    {
      title: "type",
      dataIndex: "link",
      key: "type",
      render: (text, record) => <span>{record.link.kind}</span>,
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      render: (text, record) => (
        <Button
          variant="subtle"
          size="xs"
          onClick={() => {
            setActive(record.link?.item);
            setModal2(true);
          }}
        >
          View
        </Button>
      ),
    },
    {
      title: "Action",
      dataIndex: "_id",
      key: "action",
      render: (text, record) => (
        <div className="flex gap-2 flex-wrap">
          {user?.updateBanner && (
            <Link to={`/banners/edit/${record._id}`}>
              <Button variant="light" size="xs">Edit</Button>
            </Link>
          )}
          {user?.deleteBanner && (
            <Button
              color="red"
              variant="light"
              size="xs"
              onClick={() => {
                modals.openConfirmModal({
                  title: "Delete banner",
                  children: "This action cannot be undone.",
                  labels: { confirm: "Delete", cancel: "Cancel" },
                  confirmProps: { color: "red" },
                  onConfirm: () => deleteMutation.mutate(record._id),
                });
              }}
            >
              Delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="table-page">
      <Head
        title="Banners"
        customButton={
          user?.addBanner ? (
            <Link to="/banners/add">
              <Button size="sm">Add Banner</Button>
            </Link>
          ) : null
        }
      />
      {user?.getAllBanners ? (
        <DataTable
          scroll={{ x: 800 }}
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={isLoading || deleteMutation.isPending}
        />
      ) : (
        <div className="table-card table-card-empty">
          <p className="text-zinc-500">You don&apos;t have permission to view banners</p>
        </div>
      )}
      <ViewModal active={active} modal2={modal2} setModal2={setModal2} />
    </div>
  );
};

export default Banners;
